export default __webpack_public_path__ + "static/media/reception-custom-sample.97b749fd.png";